import queryString from 'query-string';

export function convertToQueryParams(data: Record<string, any>, skipNull = true): string {
  return queryString.stringify(data, {
    skipNull,
  });
}
